export default __webpack_public_path__ + "static/media/Punto_01_Porto_Mediceo_ENG_Def.5f084949.aac";